import Compressor from 'compressorjs';

export async function compressImgUp(e, submitButtonId, profileImg) {
    const files = [...e.files];
    const container = new DataTransfer();
    $(`#${submitButtonId}`).prop('disabled', true);

    const compressPromises = files.map((file) => {
        return new Promise((resolve, reject) => {
            if (file.type.includes('image')) {
                new Compressor(file, {
                    quality: 0.2,
                    convertTypes: 'image/jpeg',
                    success(result) {
                        const blobFile = new File([result], result.name, {
                            type: 'image/jpeg',
                            lastModified: new Date().getTime(),
                        });
                        container.items.add(blobFile);
                        resolve();
                    },
                    error(err) {
                        console.log(err.message);
                        container.items.add(file);
                        resolve();
                    },
                });
            } else {
                container.items.add(file);
                resolve();
            }
        });
    });

    try {
        await Promise.all(compressPromises);
        e.files = container.files;
        $(`#${submitButtonId}`).prop('disabled', false);
        if (profileImg) {
            readImgUrlAndPreview(container.files, profileImg); // You might need to adjust this function based on your requirements.
        }
    } catch (error) {
        console.error(error);
    }
}

